import deskService from '@/api/desk'
import { QRCODES } from '../types'
import utils from '@/utils/utils'

export default {
    namespaced: true,
    state: {
      client: null,
      site: null,
      location: null,
      isDownloadingFile: false,
    },
    getters: {
        locationId: (state) => {
          return state.location
        },
        siteId: (state) => {
          return state.site
        },
        clientId: (state) => {
          return state.client
        },
        isDownloadingFile: (state) => {
          return state.isDownloadingFile
        }
    },
    mutations: {
      [QRCODES.SET_LOCATION] (state, val) {
        state.location = val
      },
      [QRCODES.SET_SITE] (state, val) {
        state.site = val
      },
      [QRCODES.SET_CLIENT] (state, val) {
        state.client = val
      },
      [QRCODES.SET_IS_DOWNLOADING_FILE] (state, value) {
        state.isDownloadingFile = value
      }
    },
    actions: {
      setLocation ({commit}, val) {
        commit(QRCODES.SET_LOCATION, val)
      },
      setSite ({commit}, val) {
        commit(QRCODES.SET_SITE, val)
      },
      setClient ({commit}, val) {
        commit(QRCODES.SET_CLIENT, val)
      },
      setIsDownloadingFile ({commit}, value) {
        commit(QRCODES.SET_IS_DOWNLOADING_FILE, value)
      },
      async getDesksQrCodesFile ({dispatch, state}) {
        try {
          dispatch('setIsDownloadingFile', true)
          let filters = {
            clientId: state.client,
            siteId: state.site,
            locationId: state.location
          }
          let response = await deskService.getDesksQrCodesFile(filters)
          dispatch('setIsDownloadingFile', false)
          let contentType = response.headers['content-type']
          let blob = new Blob([response.data], { type: contentType })
          let contentDisposition = response.headers['content-disposition']
          let fileName = utils.getFileName(contentDisposition)
          utils.handleDownload(blob, fileName)
        } catch (e) {
          dispatch('setIsDownloadingFile', false)
          dispatch('Global/showMessage', 'errorDefault', {root: true})
        }
      }
    }
}
